import React, { useState } from "react";
import {
	IEventPlayer,
	IPlayerStatGroup,
} from "@data-types/sport-stats/SportStatsTypes";

import { PlayerStatsGroupHeader, PlayerStatsGroupBody } from ".";
import classnames from "classnames";

export function PlayerStatsGroup(props: {
	player: IEventPlayer;
	statsGroup: IPlayerStatGroup;
	isExpandedHeader: boolean;
}) {
	const [isExpanded, setExpand] = useState(false);

	if (!props.isExpandedHeader) {
		return null;
	}

	return (
		<div
			className={classnames("statistics--player__item", {
				"is-collapsed": !props.isExpandedHeader,
			})}
		>
			<PlayerStatsGroupHeader
				isExpanded={isExpanded}
				onSetExpand={setExpand}
				player={props.player}
				statsGroup={props.statsGroup}
			/>

			<PlayerStatsGroupBody
				isExpanded={isExpanded}
				statsGroup={props.statsGroup}
				player={props.player}
			/>
		</div>
	);
}
